import React from 'react'
import PropTypes from 'prop-types'

import { errorImage } from './image'

const CrashForm = ({ statusCode }) => (
  <div className="crash-forms">
    <div className="container">
      <div className="t">
        <div className="img-container">
          {errorImage}
        </div>
        <div className="message-container">
          {statusCode === 502 ? (
            <>
              <h2 className='title'>Ой, в нас регламенті роботи…</h2>
              <p className='text'>Ми робимо наш додаток кращим та зручнішим.</p>
              <p className='text'>Перепрошуємо за тимчасові незручності.</p>
            </>
          ) : (
            <>
              <h2 className='title'>Щось пішло не так…</h2>
              <p className='text'>Ми працюємо над відновленням… </p>
              <p className='text'>Код помилки: {statusCode}</p>
            </>
          )}

        </div>
      </div>
    </div>
    <div className="button-container-footer">
    </div>
  </div>
)

CrashForm.propTypes = {
  statusCode: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ])
}
export default CrashForm